import { DataFieldConfig, forEstateTypes } from './data-builder';

export const balconyPatioFields: DataFieldConfig[] = [
  // {
  //   key: 'balconyPatio.balcony',
  //   label: 'Balkong',
  //   estateTypes: forEstateTypes('HousingCooperative'),
  // },
  {
    key: 'balconyPatio.parking',
    label: 'Parkering',
    estateTypes: forEstateTypes('HousingCooperative'),
  },
  // {
  //   key: 'balconyPatio.parkingLot',
  //   label: 'Parkeringsplats',
  //   estateTypes: forEstateTypes('HousingCooperative'),
  // },
  {
    key: 'balconyPatio.patio',
    label: 'Uteplats',
    estateTypes: forEstateTypes('HousingCooperative'),
    formatter: (value) => value ? 'Ja' : 'Nej',
  },
  // {
  //   key: 'balconyPatio.squereMeterype',
  //   label: '',
  //   estateTypes: forEstateTypes('HousingCooperative'),
  // },
  {
    key: 'balconyPatio.summary',
    label: 'Sammanfattning',
    estateTypes: forEstateTypes('HousingCooperative'),
  },
  // {
  //   key: 'balconyPatio.type',
  //   label: 'Allmänt om föreningen',
  //   estateTypes: forEstateTypes('HousingCooperative'),
  // },
];
